var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 324.811,
    height: 100.005,
    viewBox: "0 0 324.811 100.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.186,
    y1: -1.318,
    x2: 0.619,
    y2: 0.572,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.682,
    y1: 0.495,
    x2: -0.093,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.175,
    y1: 0.569,
    x2: -0.848,
    y2: 0.383,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.294,
    y1: -0.194,
    x2: -1.054,
    y2: 1.799,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4384",
    "data-name": "Group 4384",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1905",
    "data-name": "Rectangle 1905",
    width: 324.811,
    height: 100.005,
    rx: 20,
    transform: "translate(0 0)",
    fill: "#f0f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4383",
    "data-name": "Group 4383",
    transform: "translate(116.982 27.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    "data-name": "Path 3444",
    d: "M3063.148,1436.7a4.831,4.831,0,0,1-1.33,3.575,5.191,5.191,0,0,1-3.934,1.584,5.593,5.593,0,1,1,0-11.187,5.526,5.526,0,0,1,2.2.449,4.42,4.42,0,0,1,1.675,1.2l-.941.942a3.616,3.616,0,0,0-2.932-1.271,4.277,4.277,0,1,0,2.991,7.359,3.368,3.368,0,0,0,.9-2.169h-3.888v-1.286h5.189A4.536,4.536,0,0,1,3063.148,1436.7Z",
    transform: "translate(-3052.322 -1430.67)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    d: "M3132.182,1433.364h-4.877v3.4h4.4v1.286h-4.4v3.4h4.877v1.316h-6.251v-10.708h6.251Z",
    transform: "translate(-3113.129 -1431.808)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    d: "M3174.494,1442.756h-1.377v-9.392h-2.991v-1.316h7.358v1.316h-2.99Z",
    transform: "translate(-3149.639 -1431.808)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    "data-name": "Path 3447",
    d: "M3243.055,1442.756v-10.708h1.375v10.708Z",
    transform: "translate(-3209.884 -1431.808)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    d: "M3265.312,1442.756h-1.377v-9.392h-2.991v-1.316h7.358v1.316h-2.991Z",
    transform: "translate(-3224.662 -1431.808)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    "data-name": "Path 3449",
    d: "M3338.565,1440.234a5.561,5.561,0,0,1-7.852,0,5.785,5.785,0,0,1,0-7.941,5.542,5.542,0,0,1,7.845.007,5.767,5.767,0,0,1,.007,7.934Zm-6.836-.9a4.118,4.118,0,0,0,5.818,0,4.564,4.564,0,0,0,0-6.147,4.117,4.117,0,0,0-5.818,0,4.569,4.569,0,0,0,0,6.147Z",
    transform: "translate(-3280.995 -1430.67)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3450",
    "data-name": "Path 3450",
    d: "M3403.527,1442.756v-10.708h1.675l5.2,8.33h.059l-.059-2.064v-6.266h1.377v10.708h-1.436l-5.445-8.734h-.059l.059,2.064v6.67Z",
    transform: "translate(-3342.448 -1431.808)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3451",
    "data-name": "Path 3451",
    d: "M3097.492,1543.551a7.654,7.654,0,0,0-5.416,2.177,7.729,7.729,0,0,0,.27,11.071,7.822,7.822,0,0,0,10.044.213,7.489,7.489,0,0,0,2.721-5.87,7.477,7.477,0,0,0-7.619-7.591Zm0,12.191a4.612,4.612,0,1,1,4.284-4.6A4.392,4.392,0,0,1,3097.492,1555.742Zm-16.622-12.191a7.765,7.765,0,0,0-4.256,1.242,7.7,7.7,0,0,0-1.128,11.783,7.821,7.821,0,0,0,10.018.643,7.479,7.479,0,0,0,2.986-6.077,7.671,7.671,0,0,0-1.032-3.905A7.546,7.546,0,0,0,3080.87,1543.551Zm0,12.191a4.612,4.612,0,1,1,4.284-4.6A4.391,4.391,0,0,1,3080.87,1555.742Zm-19.772-9.862v3.22h7.706a6.722,6.722,0,0,1-1.754,4.054,7.889,7.889,0,0,1-5.952,2.358,8.569,8.569,0,0,1,0-17.136,8.213,8.213,0,0,1,5.808,2.3l2.271-2.271a11.234,11.234,0,0,0-8.08-3.249,11.953,11.953,0,0,0-6.091,1.672,11.658,11.658,0,0,0,.333,20.424,11.941,11.941,0,0,0,5.757,1.482,10.777,10.777,0,0,0,8.223-3.307,10.64,10.64,0,0,0,2.789-7.533,10.465,10.465,0,0,0-.173-2.013H3061.1Zm80.863,2.5a6.9,6.9,0,0,0-10.972-3.252,7.607,7.607,0,0,0-2.685,6.012,7.428,7.428,0,0,0,7.533,7.591,7.55,7.55,0,0,0,6.325-3.364l-2.587-1.725a4.335,4.335,0,0,1-3.738,2.1,3.862,3.862,0,0,1-3.68-2.3l10.15-4.2Zm-10.351,2.531a4.163,4.163,0,0,1,3.968-4.428,2.939,2.939,0,0,1,2.818,1.61l-3.545,1.472Zm-8.252,7.36h3.335V1535.96h-3.335Zm-5.463-13.025h-.115a5.26,5.26,0,0,0-4-1.7,7.1,7.1,0,0,0-4.75,1.9,7.683,7.683,0,0,0,.78,12.007,7.012,7.012,0,0,0,3.97,1.271,5.175,5.175,0,0,0,4-1.725h.115v1.093c0,2.9-1.552,4.457-4.054,4.457a4.2,4.2,0,0,1-3.824-2.7l-2.9,1.208a7.235,7.235,0,0,0,6.729,4.485c3.91,0,7.217-2.3,7.217-7.907v-13.629h-3.163Zm-3.824,10.495a4.617,4.617,0,0,1,0-9.2c2.271,0,4.054,1.955,4.054,4.629C3118.125,1553.816,3116.342,1555.742,3114.071,1555.742Zm43.513-19.781h-7.98v22.312h3.329v-8.453h4.65a7.626,7.626,0,0,0,5.627-2.444,6.791,6.791,0,0,0,.044-8.921A7.617,7.617,0,0,0,3157.584,1535.961Zm.086,10.753h-4.736v-7.648h4.736a3.825,3.825,0,1,1,0,7.648Zm20.581-3.2a6.253,6.253,0,0,0-5.942,3.416l2.957,1.234a3.155,3.155,0,0,1,3.042-1.636c1.722,0,3.473,1.033,3.5,2.87v.229a7.37,7.37,0,0,0-3.473-.861,8.077,8.077,0,0,0-3.88.954,4.584,4.584,0,0,0-.61,7.852,6.113,6.113,0,0,0,3.6,1.126,4.7,4.7,0,0,0,4.249-2.181h.115v1.722h3.215v-8.554a5.725,5.725,0,0,0-2.687-5.107A7.723,7.723,0,0,0,3178.251,1543.51Zm-.4,12.228c-1.09,0-2.612-.545-2.612-1.895,0-1.722,1.894-2.383,3.53-2.383a5.935,5.935,0,0,1,3.043.747A4.037,4.037,0,0,1,3177.849,1555.738Zm18.888-11.74-1.581,4-2.237,5.668h-.115l-3.961-9.673h-3.588l2.866,6.521,3.076,7-3.387,7.521h3.473l6.5-14.926,2.661-6.114Zm-30,14.274h3.329v-22.312h-3.329Z",
    transform: "translate(-2932.709 -1489.794)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3452",
    "data-name": "Path 3452",
    d: "M2759.988,1441.257l-26.521-15.561a2.887,2.887,0,0,0-3.789.778l22.462,22.593Z",
    transform: "translate(-2668.808 -1399.04)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3453",
    "data-name": "Path 3453",
    d: "M2726.456,1475.417a2.852,2.852,0,0,0,.512,1.648l22.51-22.4-22.461-22.593a2.846,2.846,0,0,0-.561,1.713Z",
    transform: "translate(-2666.146 -1404.639)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454",
    "data-name": "Path 3454",
    d: "M2866.549,1532.647l9.09-5.333a2.887,2.887,0,0,0,0-4.981l-8.956-5.255-7.848,7.809Z",
    transform: "translate(-2775.503 -1474.861)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M2729.4,1584.383a2.889,2.889,0,0,0,3.836.842l26.387-15.483-7.714-7.759Z",
    transform: "translate(-2668.58 -1511.957)",
    fill: "url(#linear-gradient-4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.3bf12abc08268607cf818d27cb6f6169.svg";
export { ForwardRef as ReactComponent };